define(function(require) {
    'use strict';

    var i18n = require('i18n');

    /**
     * DNI/NIE control letter checking algorithm implemented as on sportium.es,
     * also available on http://refiddle.com/tagged/dni
     * We need to calculate modulus of 23 from digital part and use it as index in letters list to verify control letter
     * @param digits
     * @param controlLetter
     * @param prefix
     * @returns {boolean}
     */
    const checkControlLetter = (digits, controlLetter, prefix) => {
        var prefixLettersList = 'XYZ'.split(''),
            controlLettersList = 'TRWAGMYFPDXBNJZSQVHLCKE'.split('');

        if (prefix) {
            prefix = prefix.toUpperCase();

            if (!prefixLettersList.includes(prefix)) {
                return false; // invalid NIE prefix
            }

            digits = prefixLettersList.indexOf(prefix).toString() + digits;
        }

        return controlLettersList[parseInt(digits) % 23] === controlLetter.toUpperCase();
    };

    /**
     * An eight-digit number followed by a control letter.
     * For ex.: 12345678Z
     * @param DNI
     */
    const checkDNI = (DNI) => {
        var DNIregex = /^(\d{7,8})([a-zA-Z])$/,
            validCode = DNIregex.test(DNI),
            DNIMatch = validCode && DNI.match(DNIregex),
            digits = validCode && DNIMatch[1],
            controlLetter = validCode && DNIMatch[2];

        return validCode && checkControlLetter(digits, controlLetter);
    };

    /**
     * A prefix letter (X,Y,Z), followed by a seven-digit number and control letter
     * For ex.: Y2345678Z
     * @param NIE
     */
    const checkNIE = (NIE) => {
        var NIEregex = /^([xyzXYZ])(\d{7})([a-zA-Z])$/,
            validCode = NIEregex.test(NIE),
            NIEMatch = validCode && NIE.match(NIEregex),
            prefix = validCode && NIEMatch[1],
            digits = validCode && NIEMatch[2],
            controlLetter = validCode && NIEMatch[3];

        return validCode && checkControlLetter(digits, controlLetter, prefix);
    };

    const getSpanishNameValidationConfig = (tooShortError, tooLongError, requiredError, firstNameRe = /^[A-Za-züõöÖÄß,\.\'\s\-]+$/) => {
        return {
            fn: {
                fn: function($inputs) {
                    var nameValue = $inputs[0].value || '';

                    if (nameValue.length > 40) {
                        this.message = i18n.t(tooLongError);
                        return false;
                    } else if (!nameValue) {
                        this.message = i18n.t(requiredError);
                        return false;
                    } else if (nameValue.length < 2) {
                        this.message = i18n.t(tooShortError);
                        return false;
                    } else if (!firstNameRe.test(nameValue)) {
                        this.message = i18n.t('playtech.mobile.system.user.tooltip.firstname.regexp');
                        return false;
                    }

                    return true;
                },
                message: i18n.t('playtech.mobile.system.tooltip.required')
            }
        };
    };

    return {
        checkControlLetter,
        checkDNI,
        checkNIE,
        getSpanishNameValidationConfig
    };
});
